import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PARKINGS_ACTIONS } from "../../../../redux/parkings/actions";
import {
  selectParkings,
  parkingCreating,
  parkingsFilters,
  parkingsLoaded,
  parkingsMeta,
  selectActiveParking
} from "../../../../redux/parkings/selectors";
import Confirm from "../../../../base/Confirm";
import { dateRender } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";
import { Link } from "react-router-dom";

class _Parkings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parkings: this.props.parkings,
      parkingsLoaded: this.props.parkingsLoaded,
      baseFilters: {
        "page[number]": 1,
        "page[size]": 10,
        sort: "-updated_at"
      }
    };

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    parkings: PropTypes.array,
    parkingsLoaded: PropTypes.bool,
    loadParkings: PropTypes.func,
    match: PropTypes.object,
    createParking: PropTypes.func,
    updateParking: PropTypes.func,
    deleteParking: PropTypes.func,
    parkingCreating: PropTypes.bool,
    parkingsMeta: PropTypes.object,
    filters: PropTypes.object,
    event: PropTypes.object,
    loadParking: PropTypes.func,
    activeParking: PropTypes.object,
    resetActive: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.loadParkings(this.state.baseFilters, this.props.event.id);

    if (this.props.match.params.parkingId) {
      this.props.loadParking(this.props.match.params.parkingId);
    } else {
      this.props.resetActive();
    }
  }

  _handleFilterUpdate(filters) {
    this.props.loadParkings(filters, this.props.event.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.parkingId !== nextProps.match.params.parkingId
    ) {
      this.props.loadParking(nextProps.match.params.parkingId);
    }
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this parking? This action can not be undone, please make sure no festival is using this parking.",
      {
        title: "Delete Parking",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteParking(id, this.props.event.id);
      },
      result => {}
    );
  }

  render() {
    const {
      parkingsMeta,
      filters,
      parkingCreating,
      event,
      parkings
    } = this.props;

    const listViewConf = {
      dataSet: parkings,
      dataMeta: parkingsMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "capacity",
          value: "Capacity",
          sort: "capacity"
        },
        {
          key: "updatedAt",
          value: "Updated",
          sort: "updated_at",
          render: parking => dateRender(parking.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/events/" + event.id + "/parking"
    };

    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <h3 className="m-portlet__head-text">Parking</h3>
                </div>
              </div>
              <div className="m-portlet__head-tools">
                <ul className="m-portlet__nav m--margin-left-20">
                  <li className="m-portlet__nav-item">
                    <Link
                      to={"/admin/events/" + event.id + "/parking/create"}
                      className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                    >
                      <span>
                        <i className="la la-plus" />
                        <span>Add Parking</span>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <ListView
              keepPadding
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadParkings: (filters, eventId) =>
    dispatch(PARKINGS_ACTIONS.loadAllRequest(filters, eventId)),
  loadParking: (id, eventId) =>
    dispatch(PARKINGS_ACTIONS.loadRequest(id, eventId)),
  resetActive: () => dispatch(PARKINGS_ACTIONS.resetActive()),
  createParking: (values, eventId) =>
    dispatch(PARKINGS_ACTIONS.createRequest(values, eventId)),
  updateParking: (id, values, eventId) =>
    dispatch(PARKINGS_ACTIONS.updateRequest(id, values, eventId)),
  deleteParking: (id, eventId) =>
    dispatch(PARKINGS_ACTIONS.deleteRequest(id, eventId))
});

const mapStateToProps = function(state) {
  return {
    parkings: selectParkings(state),
    parkingsLoaded: parkingsLoaded(state),
    parkingCreating: parkingCreating(state),
    parkingsMeta: parkingsMeta(state),
    filters: parkingsFilters(state),
    activeParking: selectActiveParking(state)
  };
};

const Parkings = connect(mapStateToProps, mapDispatchToProps)(_Parkings);

export default Parkings;
